import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { StoreInfo } from '@/types/store';

type ViewedStoreInfoState = {
  data: StoreInfo | null;
};

const initialState: ViewedStoreInfoState = {
  data: null,
};

const viewedStoreInfoSlice = createSlice({
  name: 'viewedStore',
  initialState,
  reducers: {
    setViewedStore(state, action: PayloadAction<StoreInfo>) {
      state.data = action.payload;
    },
    clearViewedStore(state) {
      state.data = null;
    },
  },
});

export const { setViewedStore, clearViewedStore } = viewedStoreInfoSlice.actions;
export default viewedStoreInfoSlice.reducer;
